<script setup lang="ts">
import { onMounted, shallowRef } from "vue";
import { AgGridVue } from "ag-grid-vue3";
import {
  themeQuartz,
  type GridApi,
  type GridOptions,
  type GridReadyEvent,
} from "ag-grid-enterprise";
import {useCharterSeasonsStore} from "@/charter/stores/charter-seasons-store.ts";

const seasonsStore = useCharterSeasonsStore();

const myTheme = themeQuartz.withParams({});

const gridOptions: GridOptions = {
  pagination: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
    defaultMinWidth: 100,
  },
  defaultColDef: {
    resizable: false,
    filter: true,
  },
  columnDefs: [
    { field: "id", headerName: "ID" },
    { field: "code", headerName: "Code" },
    { field: "name", headerName: "Name" },
    { field: "startDate", headerName: "Start Date" },
    { field: "endDate", headerName: "End Date" },
    { field: "isActive", headerName: "Active" },
  ],
};

const gridApi = shallowRef<GridApi | null>(null);

onMounted(async () => {
  await seasonsStore.fetchSeasons();
});

function onGridReady(params: GridReadyEvent) {
  gridApi.value = params.api;
}

async function refreshData() {
  await seasonsStore.fetchSeasons();
}
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <div class="flex items-center justify-between">
      <h2>Seasons</h2>
      <div class="flex gap-2">
        <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" outlined @click="refreshData" />
      </div>
    </div>

    <AgGridVue
      :rowData="seasonsStore.seasons"
      :loading="seasonsStore.isLoading"
      :gridOptions="gridOptions"
      :theme="myTheme"
      class="ag-grid-container"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<style scoped lang="scss">
.ag-grid-container {
  width: 100%;
  height: 400px;
}

h2 {
  margin: 0 !important;
}

.p-button {
  min-height: fit-content !important;
}

.p-button-icon-left {
  margin-right: 0.4375rem !important;
}

.p-button-label {
  font-weight: 700 !important;
}

.p-button-outlined {
  background-color: white !important;
  color: rgb(30, 41, 59) !important;
  font-size: 14px;
  line-height: 21px !important;
  padding: 6px 10px;
  border-radius: 6px;
  border-color: #e2e8f0 !important;
}

.p-button-outlined:hover {
  background-color: var(--p-button-outlined-secondary-hover-background) !important;
}

.p-button-outlined:active {
  background-color: var(--p-button-outlined-secondary-active-background) !important;
}
</style>
